'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:HotelController
 * @description
 * # HotelController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('HotelController', function ($scope, BasicService, Utils, ActCourseService, APIs, ConfigService) {
        var vm = this;
        vm.hotelList = [];
        vm.selectedHotel = undefined;
        vm.showAddHotelRoom = false;
        vm.showEditHotelRoom = false;
        vm.showAttendee2HotelRoom = false;

        vm.showDialog = function (dialog) {
            vm[dialog] = true;
        };

        vm.hideDialog = function (dialog) {
            vm[dialog] = false;
        };

        vm.loadHotelList = function () {
            vm.hotelList = [];
            APIs.CourseHotelService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (courseHotel) {
                    vm.hotelList.push(courseHotel);
                });
            });
        };

        vm.loadAttendeeList = function () {
            vm.attendeeList = [];
            APIs.AttendeeService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendee) {
                    vm.attendeeList.push(attendee);
                });
            });
        };

        vm.hotelRooms = [];
        vm.loadHotelRooms = function () {
            APIs.HotelRoomService.query({ hotel: vm.selectedHotel.id }).$promise.then(function (hrs) {
                vm.hotelRooms = [];
                angular.forEach(hrs, function (hr) {
                    vm.hotelRooms.push(hr);
                });
                vm.loadHotelRoomAttendees();
                vm.updateHotelRooms();
            });
        };
        vm.updateHotelRooms = function () {
            var actPage = vm.tableParamsHotelRooms.parameters().page;
            vm.tableParamsHotelRooms.settings({
                dataset: vm.hotelRooms
            });
            var maxPages = vm.tableParamsHotelRooms.total() / vm.tableParamsHotelRooms.count();
            if (maxPages < 1) {
                vm.tableParamsHotelRooms.page(1);
            } else if (actPage <= maxPages) {
                vm.tableParamsHotelRooms.page(actPage);
            } else {
                vm.tableParamsHotelRooms.page(actPage - Math.round(actPage - maxPages));
            }
        };

        vm.hotelRoomAttendees = [];
        vm.loadHotelRoomAttendees = function () {
            vm.hotelRoomAttendees = [];
            var hotelRoomAttendeesList = [];

            APIs.HotelRoomAttendeesService.query({ hotel_room__hotel: vm.selectedHotel.id }).$promise.then(function (hra) {
                angular.forEach(hra, function (hotelRoomAttendee) {
                    hotelRoomAttendeesList.push(hotelRoomAttendee);
                });

                // update the list of room and attendee
                angular.forEach(vm.hotelRooms, function (hr) {
                    var hras = BasicService.filter('filter')(hotelRoomAttendeesList, { hotel_room: hr.id }, true);
                    angular.forEach(hras, function (hra) {
                        var a = BasicService.filter('filter')(vm.attendeeList, { id: hra.attendee }, true);
                        vm.hotelRoomAttendees.push({ id: hra.id, attendee: a[0], hotel_room: hr });
                    });

                    for (var i = hras.length; i < hr.countRoom; i++) {
                        vm.hotelRoomAttendees.push({ hotel_room: hr });
                    }
                });
                vm.updateHotelRoomAttendees();
            });
        };
        vm.updateHotelRoomAttendees = function () {
            var actPage = vm.tableParamsHRA.parameters().page;
            vm.tableParamsHRA.settings({
                dataset: vm.hotelRoomAttendees
            });
            var maxPages = vm.tableParamsHRA.total() / vm.tableParamsHRA.count();
            if (maxPages < 1) {
                vm.tableParamsHRA.page(1);
            } else if (actPage <= maxPages) {
                vm.tableParamsHRA.page(actPage);
            } else {
                vm.tableParamsHRA.page(actPage - Math.round(actPage - maxPages));
            }
        };

        vm.printHotel = function (sort) {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/hotel/' + vm.selectedHotel.id + '/?sort=' + sort;
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_' + vm.selectedHotel.hotel.name + '.pdf');
            vm.hideDialog('printDialog');
        };

        // watch for changes on selectedHotel
        $scope.$watch(function () {
            return vm.selectedHotel;
        }, function () {
            if (angular.isDefined(vm.selectedHotel)) {
                vm.loadHotelRooms();
            }
        });

        vm.addHotelRoom = function (hotelRoom) {
            for (var index = 0; index < hotelRoom.countRoomFollow; index++) {
                var roomNr = '';
                if (isNaN(parseInt(hotelRoom.room, 10))) {
                    roomNr = hotelRoom.room + ' - ' + (index + 1);
                } else {
                    roomNr = parseInt(hotelRoom.room, 10) + index;
                }
                APIs.HotelRoomService.save({ hotel: vm.selectedHotel.id, room: roomNr, countRoom: hotelRoom.countRoom }, function (hrData) {
                    vm.hotelRooms.push(hrData);
                    vm.updateHotelRooms();
                    for (var i = 0; i < hrData.countRoom; i++) {
                        vm.hotelRoomAttendees.push({ hotel_room: hrData });
                    }
                    vm.updateHotelRoomAttendees();
                });
            }
            vm.hideDialog('showAddHotelRoom');
        };

        vm.saveEditHotelRoom = function (hotelRoom) {
            var update = angular.copy(vm.editHotelRoom);
            angular.forEach(hotelRoom, function (value, key) {
                update[key] = value;
            }, update);

            APIs.HotelRoomService.update(update, function (hrData) {
                vm.hotelRooms.splice(vm.hotelRooms.indexOf(vm.editHotelRoom), 1, hrData);
                vm.updateHotelRooms();
                var hras = BasicService.filter('filter')(vm.hotelRoomAttendees, { hotel_room: { id: vm.editHotelRoom.id } }, true);
                angular.forEach(hras, function (hrasE) {
                    hrasE.hotel_room = hrData;
                });
                if (hras.length < hrData.countRoom) {
                    // add missing beds
                    for (var i = hras.length; i < hrData.countRoom; i++) {
                        vm.hotelRoomAttendees.push({ hotel_room: hrData });
                    }
                } else if (hras.length > hrData.countRoom) {
                    // remove to much beds
                    var r = hras.length - hrData.countRoom;
                    vm.hotelRoomAttendees.splice(vm.hotelRoomAttendees.indexOf(hras[0]), r);
                }
                vm.updateHotelRoomAttendees();
                vm.hideDialog('showEditHotelRoom');
            });
        };

        vm.delHotelRoom = function (hotelRoom) {
            hotelRoom = BasicService.filter('filter')(vm.hotelRooms, { id: hotelRoom.id })[0];
            APIs.HotelRoomService.delete(hotelRoom, function () {
                vm.hotelRooms.splice(vm.hotelRooms.indexOf(hotelRoom), 1);
                vm.updateHotelRooms();
                var hras = BasicService.filter('filter')(vm.hotelRoomAttendees, { hotel_room: { id: hotelRoom.id } }, true);
                vm.hotelRoomAttendees.splice(vm.hotelRoomAttendees.indexOf(hras[0]), hras.length);
                vm.updateHotelRoomAttendees();
                vm.hideDialog('showEditHotelRoom');
            });
        };

        vm.showEditHotelRoomDialog = function (hotelRoom) {
            vm.editHotelRoom = BasicService.filter('filter')(vm.hotelRooms, { id: hotelRoom.id })[0];
            vm.showDialog('showEditHotelRoom');
        };

        vm.disableHotelRoomCountField = function () {
            if (angular.isDefined(vm.editHotelRoom)) {
                var hras = BasicService.filter('filter')(vm.hotelRoomAttendees, { hotel_room: { id: vm.editHotelRoom.id } }, true);
                var attendeCount = 0;
                angular.forEach(hras, function (hrasE) {
                    if (angular.isDefined(hrasE.attendee)) {
                        attendeCount++;
                    }
                });
                return attendeCount > 0;
            }
            return false;
        };

        vm.showAttendee2HotelRoomDialog = function (hotelRoomAttendee) {
            vm.addHotelRoomA = hotelRoomAttendee;
            vm.tableParamsAttendees.settings({
                dataset: vm.attendeeList
            });
            vm.showDialog('showAttendee2HotelRoom');
            var nameElements = BasicService.document[0].getElementsByName('person.name');
            if (nameElements.length >= 1) {
                BasicService.timeout(function () {
                    nameElements[0].focus();
                });
            }
        };

        vm.saveAttendee2HotelRoom = function (attendee) {
            APIs.HotelRoomAttendeesService.save({ attendee: attendee.id, hotel_room: vm.addHotelRoomA.hotel_room.id }, function (data) {
                var hras = BasicService.filter('filter')(BasicService.filter('filter')(vm.hotelRoomAttendees, { id: '!' }), { id: undefined, hotel_room: { id: data.hotel_room } }, true);
                var a = BasicService.filter('filter')(vm.attendeeList, { id: data.attendee }, true);
                var hr = BasicService.filter('filter')(vm.hotelRooms, { id: data.hotel_room }, true);
                vm.hotelRoomAttendees.splice(vm.hotelRoomAttendees.indexOf(hras[0]), 1, { id: data.id, attendee: a[0], hotel_room: hr[0] });

                vm.updateHotelRoomAttendees();
                vm.tableParamsAttendees.filter({});
                vm.hideDialog('showAttendee2HotelRoom');
            });
        };

        vm.checkAttendeeHasHotelRoom = function (attendee) {
            var checkA = BasicService.filter('filter')(vm.hotelRoomAttendees, { attendee: { id: attendee.id } }, true);
            return checkA.length > 0;
        };

        vm.delAttendeeFromHotelRoom = function (hotelRoomAttendee) {
            hotelRoomAttendee = BasicService.filter('filter')(vm.hotelRoomAttendees, { id: hotelRoomAttendee.id })[0];
            APIs.HotelRoomAttendeesService.delete(hotelRoomAttendee, function () {
                vm.hotelRoomAttendees.splice(vm.hotelRoomAttendees.indexOf(hotelRoomAttendee), 1);
                vm.hotelRoomAttendees.push({ hotel_room: hotelRoomAttendee.hotel_room });
                vm.updateHotelRoomAttendees();
            });
        };

        vm.colsHotelRooms = [
            { valueExpr: 'hotelRoom.room', title: 'Zimmer-Nr.', sortable: 'room', filter: { room: 'text' }, show: true },
            { valueExpr: 'hotelRoom.countRoom', title: 'Betten', filter: { countRoom: 'number' }, show: true },
            { field: 'action', title: '', dataType: 'command', class: 'actionWidth90' }
        ];

        vm.tableParamsHotelRooms = new ConfigService.NgTableParams({ page: 1, count: 10, sorting: { room: 'asc' } }, {
            counts: [10, 20, 30],
            defaultSelectValue: 'Show all',
            dataset: vm.hotelRooms
        });

        vm.colsHRA = [
            { valueExpr: 'hrAttendee.hotel_room.room', title: 'Zimmer-Nr.', sortable: 'hotel_room.room', filter: { 'hotel_room.room': 'text' }, show: true },
            { valueExpr: 'hrAttendee.attendee.person.name', title: 'Name', filter: { 'attendee.person.name': 'text' }, show: true },
            { valueExpr: 'hrAttendee.attendee.person.first_name', title: 'Vorname', filter: { 'attendee.person.first_name': 'text' }, show: true },
            { field: 'action', title: '', dataType: 'command', class: 'actionWidth90' }
        ];

        vm.tableParamsHRA = new ConfigService.NgTableParams({ page: 1, count: 10, sorting: { 'hotel_room.room': 'asc' } }, {
            counts: [10, 20, 30],
            defaultSelectValue: 'Show all',
            dataset: vm.hotelRoomAttendees
        });

        vm.colsAttendees = [
            { valueExpr: 'attendee.person.name', title: 'Name', sortable: 'person.name', filter: { 'person.name': 'text' }, show: true },
            { valueExpr: 'attendee.person.first_name', title: 'Vorname', sortable: 'person.first_name', filter: { 'person.first_name': 'text' }, show: true },
            { field: 'action', title: '', dataType: 'command' }
        ];

        vm.tableParamsAttendees = new ConfigService.NgTableParams({ page: 1, count: 5 }, {
            counts: [],
            defaultSelectValue: 'Show all',
            dataset: vm.attendeeList
        });

        vm.selectedCourse = ActCourseService.getActCourse();
        if (angular.isDefined(vm.selectedCourse)) {
            vm.loadHotelList();
            vm.loadAttendeeList();
        }
    });
